import { render } from "./StorePurchaseRequisitionEdit.vue?vue&type=template&id=0552290c&scoped=true"
import script from "./StorePurchaseRequisitionEdit.vue?vue&type=script&lang=js"
export * from "./StorePurchaseRequisitionEdit.vue?vue&type=script&lang=js"

import "./StorePurchaseRequisitionEdit.vue?vue&type=style&index=0&id=0552290c&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0552290c"]])

export default __exports__